import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import s from './Product.module.scss'

// 产品配置数据
const PRODUCTS_CONFIG = [
  {
    id: 'goose3t',
    to: '/temp-rh-monitor-3t/overview',
    className: s.goose,
    titleId: 'goose3t',
    isNew: true,
    features: {
      en: ['gs3t_first_desc_2', 'goose_screen', 'goose_support_3'],
      cn: [
        { text: 'gs3t_first_desc_2' },
        { text: 'goose_screen', separator: '·' },
        { text: 'goose_support_3', breakBefore: true }
      ]
    }
  },
  {
    id: 'goose3duck3',
    to: '/temp-rh-monitor-3/overview',
    className: s.duck3,
    titleId: 'gd3_title',
    isNew: true,
    features: {
      en: ['goose_support_3', 'duck2_support', 'user'],
      cn: [
        { text: 'goose_support_3' },
        { text: 'duck2_support', separator: '·' },
        { text: 'user', breakBefore: true }
      ]
    }
  },
  {
    id: 'magpie',
    to: '/lee-guitars-thermo-hygrometer/overview',
    className: s.magpie,
    titleId: 'magpie',
    titleValues: { br: <br /> },
    features: {
      en: ['grasp_guitar_sip', 'e_link', 'record_history_data'],
      cn: [
        { text: 'grasp_guitar_sip' },
        { text: 'e_link', separator: '·' },
        { text: 'record_history_data', separator: '·' }
      ]
    }
  },
  {
    id: 'hodor',
    to: '/door-window-sensor/overview',
    className: s.hodor,
    titleId: 'hodor',
    features: {
      en: ['hodor_monitor', 'automation', 'p_wifi_value'],
      cn: [
        { text: 'hodor_monitor' },
        { text: 'automation', separator: '·' },
        { text: 'p_wifi_value', breakBefore: true }
      ]
    }
  },
  {
    id: 'parrot',
    to: '/motion-light-sensor/overview',
    className: s.parrot,
    titleId: 'parrot_title',
    features: {
      en: ['parrot_des1_1', 'parrot_des1_2', 'parrot_des2'],
      cn: [
        { text: 'parrot_des1' },
        { text: 'parrot_des2', breakBefore: true }
      ]
    }
  },
  {
    id: 'dove',
    to: '/bluetooth-alarm-clock/overview',
    className: s.dove,
    titleId: 'dove',
    features: {
      en: ['button_less', 'temp_rh_mon', 'soft_backlight', 'sixteen_ala'],
      cn: [
        { text: 'button_less' },
        { text: 'temp_rh_mon', separator: '·' },
        { text: 'soft_backlight', breakBefore: true },
        { text: 'sixteen_ala', separator: '·' }
      ]
    }
  },
  {
    id: 'sparrow',
    to: '/bluetooth-gateway/overview',
    className: s.sparrow,
    titleId: 'sparrow',
    features: {
      en: ['connect_mi_en_1', 'enable_remote', 'automation'],
      cn: [
        { text: 'connect_mi' },
        { text: 'enable_remote', breakBefore: true },
        { text: 'automation', separator: '·' }
      ]
    }
  },
  {
    id: 'pheasant',
    to: '/temp-rh-monitor-pro-s/overview',
    className: s.lora,
    titleId: 'pheasant_s',
    titleValues: { br: <br /> },
    features: {
      en: ['l_support', 'l_battery', 'l_user'],
      cn: [
        { text: 'l_support' },
        { text: 'l_battery', breakBefore: true },
        { text: 'l_user', separator: '·' }
      ]
    }
  },
  {
    id: 'frogs',
    to: '/multi-role-monitor/overview',
    className: s.frogs,
    titleId: 'frogs',
    titleValues: { br: <br /> },
    isNew: true,
    features: {
      en: ['frogs_support_1', 'frogs_support_2', 'frog_support_4'],
      cn: [
        { text: 'frogs_support_1' },
        { text: 'frogs_support_2', separator: '·' },
        { text: 'frog_support_4', breakBefore: true }
      ]
    }
  },
  {
    id: 'pheasant_co2',
    to: '/co2-temp-rh-monitor/overview',
    className: s.pheasant_co2,
    titleId: 'pheasant_co2_title',
    titleStyle: { paddingRight: '45%' },
    features: {
      en: ['pheasant_co2_des1_1', 'pheasant_co2_des1_2', 'pheasant_co2_des2'],
      cn: [
        { text: 'pheasant_co2_des1' },
        { text: 'pheasant_co2_des2', breakBefore: true }
      ]
    }
  },
  {
    id: 'robb',
    to: '/indoor-environment-monitor/overview',
    className: s.robb,
    titleId: 'robb',
    isNew: true,
    features: {
      en: [
        { text: 'robb_product_desc_m_e_1', values: { br: <br /> } },
        'robb_product_desc_m_e_2',
        'robb_product_desc_m_e_3'
      ],
      cn: [
        { text: 'robb_product_desc1', values: { br: <br /> } },
        { text: 'robb_product_desc2', breakBefore: true }
      ]
    }
  },
  {
    id: 'snow2',
    to: '/air-monitor-2/overview',
    className: s.snow,
    titleId: 'snow2',
    customRender: true
  },
  {
    id: 'dany',
    to: '/air-monitor-lite/overview',
    className: s.dany,
    titleId: 'dany',
    customRender: true
  }
]

// 服务/平台配置
const SERVICES_CONFIG = [
  {
    id: 'cgapp',
    to: '/home-app',
    className: s.qingpingiot,
    leftIcon: s.plus_left,
    titleId: 'cg_app',
    features: {
      en: ['device_management', 'data_insights', 'historical_data', 'access_remote'],
      cn: [
        { text: 'device_management' },
        { text: 'data_insights', separator: '·' },
        { text: 'historical_data', breakBefore: true },
        { text: 'access_remote', separator: '·' }
      ]
    }
  },
  {
    id: 'iot',
    href: 'https://qingpingiot.com',
    to: '/iot',
    className: s.qingpingiot,
    leftIcon: s.qingpingiot_left,
    titleId: 'qing_ping_iot',
    features: {
      en: ['team_management', 'data_collection', 'device_sharing', 'alarm_notification'],
      cn: [
        { text: 'team_management' },
        { text: 'data_collection', separator: '·' },
        { text: 'device_sharing', breakBefore: true },
        { text: 'alarm_notification', separator: '·' }
      ]
    }
  },
  {
    id: 'developer',
    href: 'https://developer.qingping.co',
    className: s.qingpingiot,
    leftIcon: s.developer_left,
    titleId: 'index_developer',
    features: {
      en: ['customize_device', 'own_platform_m_1', 'own_platform_m_2'],
      cn: [
        { text: 'customize_device' },
        { text: 'own_platform_m_1', separator: '·' },
        { text: 'own_platform_m_2', breakBefore: true }
      ]
    }
  }
]

// 产品列表项组件 - 英文版
const ProductItemEN = ({ product, onClickLink, locale }) => {
  const { className, to, titleId, titleValues, titleStyle, isNew } = product

  // snow2 产品的自定义渲染
  if (product.id === 'snow2') {
    return (
      <li className={className}>
        <Link to={to} onClick={onClickLink}>
          <div className={s.title}>
            <FormattedMessage id={titleId} />
          </div>
          <ul className={s.ul}>
            <li>
              <FormattedMessage id="pm25" />
              <span>·&nbsp;</span>
              <FormattedMessage id="pm10" />
              <span>·&nbsp;</span>
              <FormattedMessage id="noise" />
              <span>·&nbsp;</span>
              <FormattedMessage id="co2" />
              <br />
              <FormattedMessage id="etvoc" />
              <span>·&nbsp;</span>
              <FormattedMessage id="temp_m" />
              <br />
              {locale.indexOf('US') === -1 && <FormattedMessage id="hum" />}
            </li>
            <li><FormattedMessage id="snow2_sensor" /></li>
            <li><FormattedMessage id="snow_screen" /></li>
          </ul>
        </Link>
      </li>
    )
  }

  // dany 产品的自定义渲染
  if (product.id === 'dany') {
    return (
      <li className={className}>
        <Link to={to} onClick={onClickLink}>
          <div className={s.title}>
            <FormattedMessage id={titleId} />
          </div>
          <ul className={s.ul}>
            <li>
              <FormattedMessage id="pm25" />
              <span>,&nbsp;</span>
              <FormattedMessage id="co2" />
              <span>,&nbsp;</span>
              <FormattedMessage id="temp_m" />
              <br />
              {locale.indexOf('US') === -1 && <FormattedMessage id="hum" />}
            </li>
            <li><FormattedMessage id="touchbar" /></li>
            <li><FormattedMessage id="support_all" values={{ br: <br /> }} /></li>
          </ul>
        </Link>
      </li>
    )
  }

  // 常规产品渲染
  return (
    <li className={className}>
      <Link to={to} onClick={onClickLink}>
        <div className={s.title} style={titleStyle}>
          <FormattedMessage id={titleId} values={titleValues} />
          {isNew && (
            <div className={s.new_tag}>
              <FormattedMessage id="new_tag" />
            </div>
          )}
        </div>
        <ul className={s.ul}>
          {product.features.en.map((feature, index) => {
            const featureData = typeof feature === 'string' ? { text: feature } : feature
            return (
              <li key={index}>
                <FormattedMessage id={featureData.text} values={featureData.values} />
              </li>
            )
          })}
        </ul>
      </Link>
    </li>
  )
}

// 产品列表项组件 - 中文版
const ProductItemCN = ({ product, onClickLink }) => {
  const { className, to, titleId, titleValues, titleStyle, isNew } = product

  // snow2 产品的自定义渲染
  if (product.id === 'snow2') {
    return (
      <li className={className}>
        <Link to={to} onClick={onClickLink}>
          <div className={s.title}>
            <FormattedMessage id={titleId} />
          </div>
          <div className={s.desc}>
            <FormattedMessage id="pm25" />
            <span>&nbsp;·&nbsp;</span>
            <FormattedMessage id="pm10" />
            <span>&nbsp;·&nbsp;</span>
            <FormattedMessage id="noise" />
            <span>&nbsp;·&nbsp;</span>
            <FormattedMessage id="co2" />
            <br />
            <FormattedMessage id="etvoc" />
            <span>&nbsp;·&nbsp;</span>
            <FormattedMessage id="temp" />
            <br />
            <FormattedMessage id="hum" />
            <span className={s.line}>·</span>
            <FormattedMessage id="snow2_sensor" />
            <span className={s.line}>·</span>
            <FormattedMessage id="snow_screen" />
          </div>
        </Link>
      </li>
    )
  }

  // dany 产品的自定义渲染
  if (product.id === 'dany') {
    return (
      <li className={className}>
        <Link to={to} onClick={onClickLink}>
          <div className={s.title}>
            <FormattedMessage id={titleId} />
          </div>
          <div className={s.desc}>
            <FormattedMessage id="pm25" />
            <span>&nbsp;·&nbsp;</span>
            <FormattedMessage id="co2" />
            <span>&nbsp;·&nbsp;</span>
            <FormattedMessage id="temp" />
            <br />
            <FormattedMessage id="hum" />
            <span className={s.line}>·</span>
            <FormattedMessage id="touchbar" />
            <span className={s.line}>·</span>
            <FormattedMessage id="support_all" values={{ br: <br /> }} />
          </div>
        </Link>
      </li>
    )
  }

  // 常规产品渲染
  return (
    <li className={className}>
      <Link to={to} onClick={onClickLink}>
        <div className={s.title} style={titleStyle}>
          <FormattedMessage id={titleId} values={titleValues || { br: '' }} />
          {isNew && (
            <div className={s.new_tag}>
              <FormattedMessage id="new_tag" />
            </div>
          )}
        </div>
        <div className={s.desc}>
          {product.features.cn.map((feature, index) => (
            <React.Fragment key={index}>
              {feature.breakBefore && <br />}
              {feature.separator && <span className={s.line}>{feature.separator}</span>}
              <FormattedMessage id={feature.text} values={feature.values} />
            </React.Fragment>
          ))}
        </div>
      </Link>
    </li>
  )
}

// 服务/平台项组件 - 英文版
const ServiceItemEN = ({ service, onClickLink }) => {
  const { className, href, to, leftIcon, titleId, features } = service

  const content = (
    <div className={s.qingpingiot_content}>
      <div className={leftIcon}></div>
      <div className={s.qingpingiot_right}>
        <div className={s.title}>
          <FormattedMessage id={titleId} />
        </div>
        <ul className={s.ul}>
          {features.en.map((featureId, index) => (
            <li key={index}>
              <FormattedMessage id={featureId} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )

  return (
    <li className={className}>
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      ) : (
        <Link to={to} onClick={onClickLink}>
          {content}
        </Link>
      )}
    </li>
  )
}

// 服务/平台项组件 - 中文版
const ServiceItemCN = ({ service, onClickLink }) => {
  const { className, href, to, leftIcon, titleId, features } = service

  const content = (
    <div className={s.qingpingiot_content}>
      <div className={leftIcon}></div>
      <div className={s.qingpingiot_right}>
        <div className={s.title}>
          <FormattedMessage id={titleId} />
        </div>
        <div className={s.desc}>
          {features.cn.map((feature, index) => (
            <React.Fragment key={index}>
              {feature.breakBefore && <br />}
              {feature.separator && <span className={s.line}>{feature.separator}</span>}
              <FormattedMessage id={feature.text} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )

  return (
    <li className={className}>
      {service.id === 'iot' ? (
        <Link to={to} onClick={onClickLink}>
          {content}
        </Link>
      ) : href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      ) : (
        <Link to={to} onClick={onClickLink}>
          {content}
        </Link>
      )}
    </li>
  )
}

const Product = ({ locale }) => {
  const toTop = useCallback(() => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }, [])

  const isEnglish = locale.indexOf('US') > -1

  return (
    <div className={s.product}>
      {isEnglish ? (
        <ul className={s.ul_en}>
          {PRODUCTS_CONFIG.map((product) => (
            <ProductItemEN
              key={product.id}
              product={product}
              onClickLink={toTop}
              locale={locale}
            />
          ))}
          {SERVICES_CONFIG.map((service) => (
            <ServiceItemEN
              key={service.id}
              service={service}
              onClickLink={toTop}
            />
          ))}
        </ul>
      ) : (
        <ul className={s.ul_cn}>
          {PRODUCTS_CONFIG.map((product) => (
            <ProductItemCN
              key={product.id}
              product={product}
              onClickLink={toTop}
            />
          ))}
          {SERVICES_CONFIG.map((service) => (
            <ServiceItemCN
              key={service.id}
              service={service}
              onClickLink={toTop}
            />
          ))}
        </ul>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  locale: state.language,
})

export default connect(mapStateToProps)(Product)
